import { useMemo } from "react";
import Chart from "react-apexcharts";
import { ContainerGrafico } from "../ContainerGrafico";
import { Serie } from "../GraficoBarra";

interface GraficoBarraEmpilhadaProps {
  title: string;
  categories: string[];
  series: Serie[];
  onClick?: () => void;
}

export function GraficoBarraEmpilhada({
  title,
  categories,
  series,
  onClick,
}: GraficoBarraEmpilhadaProps) {
  const maxItems = 5;

  const limitedCategories = categories.slice(0, maxItems);

  const formatLargeNumbers = (num: number): string => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1).replace(".0", "") + "M";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1).replace(".0", "") + "k";
    } else {
      return num.toString();
    }
  };

  const options: ApexCharts.ApexOptions = useMemo(() => {
    return {
      series,
      chart: {
        type: "bar",
        height: 350,
        stacked: true,
        stackType: "normal",
        toolbar: { show: false },
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          horizontal: true,
          barHeight: "80%",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: 1,
        colors: ["#fff"],
      },
      xaxis: {
        categories,
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: {
          formatter: function (val: number) {
            return formatLargeNumbers(val) + " Itens";
          },
        },
        custom: function ({
          series,
          dataPointIndex,
          w,
        }: {
          series: number[][];
          seriesIndex: number;
          dataPointIndex: number;
          w: any;
        }) {
          const seriesNames = w.config.series as { name: string }[];
          const dataPoints = series
            .map((s: number[], idx: number) => {
              const value = s[dataPointIndex];
              if (value > 0) {
                return `<span><b>${
                  seriesNames[idx].name
                }:</b> ${formatLargeNumbers(value)} Itens</span><br/>`;
              }
              return "";
            })
            .filter((item: string) => item !== "");

          const totalItens = series
            .map((s: number[]) => s[dataPointIndex])
            .filter((value: number) => value > 0)
            .reduce((acc: number, curr: number) => acc + curr, 0);

          return `
            <div class="apexcharts-tooltip-custom">
              ${dataPoints.join("")}
            </div>
            <div class="apexcharts-tooltip-custom">
              <b>TOTAL:</b> ${formatLargeNumbers(totalItens)} Itens
            </div>
          `;
        },
      },
      fill: {
        opacity: 1,
      },
      legend: {
        position: "top",
        horizontalAlign: "left",
        offsetX: 40,
      },
    };
  }, [limitedCategories]);

  return (
    <ContainerGrafico title={title} onClick={onClick}>
      <Chart
        options={options}
        series={options.series}
        type="bar"
        height={350}
      />
    </ContainerGrafico>
  );
}
